export default function EmptyState({ title = "Sin datos", message = "No hay información para mostrar." }) {
    return (
        <div className="empty-state">
            <h3>{title}</h3>
            <p>{message}</p>
        </div>
    );
}